import React, { useEffect } from 'react';
import { accountsLoginUrl, SKIP_SSO_AUTO_KEY } from '../accounts';

const AUTH_KEYS = [
  'authToken',
  'isAuthenticated',
  'userEmail',
  'userId',
  'userName',
  'userRole',
  'metrica_tenant',
  'metrica_auth',
];

function allowedContinue(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
    const host = parsed.hostname.toLowerCase();
    const allowed = new Set([
      'accounts.metrica.co.il',
      'staging.accounts.metrica.co.il',
      'expenses.metrica.co.il',
      'staging.expenses.metrica.co.il',
      'foodcost.metrica.co.il',
      'staging.foodcost.metrica.co.il',
      'tasks.metrica.co.il',
      'staging.tasks.metrica.co.il',
      'localhost',
      '127.0.0.1',
    ]);
    return allowed.has(host);
  } catch {
    return false;
  }
}

/** Front-channel logout target for Accounts SSO (`/logout?continue=...`). */
const LogoutPage: React.FC = () => {
  useEffect(() => {
    for (const key of AUTH_KEYS) {
      localStorage.removeItem(key);
    }
    sessionStorage.setItem(SKIP_SSO_AUTO_KEY, '1');
    window.dispatchEvent(new Event('authStateChanged'));
    const cont = new URLSearchParams(window.location.search).get('continue');
    if (cont && allowedContinue(cont)) {
      window.location.replace(cont);
      return;
    }
    window.location.replace(accountsLoginUrl());
  }, []);

  return (
    <div className="appLoading" role="status" aria-live="polite">
      <div className="appLoadingSpinner" />
      <span>מתנתק...</span>
    </div>
  );
};

export default LogoutPage;
